import Test from '../ember-testing/lib/test.js';
import Adapter from '../ember-testing/lib/adapters/adapter.js';
import setupForTesting from '../ember-testing/lib/setup_for_testing.js';
import QUnitAdapter from '../ember-testing/lib/adapters/qunit.js';
import '../ember-testing/lib/ext/application.js';
import '../ember-testing/lib/ext/rsvp.js';
import '../ember-testing/lib/helpers.js';
import '../ember-testing/lib/initializers.js';

// to setup initializer

const EmberTesting = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	Adapter,
	QUnitAdapter,
	Test,
	setupForTesting
}, Symbol.toStringTag, { value: 'Module' }));

export { EmberTesting as E };
